module.exports = __webpack_public_path__ + "img/frame_cxtd_titlebg.0d10af1d.png";